export default "__VITE_ASSET__zOIObe7X__"